'use client';

import Script from 'next/script';

declare global {
  interface Window { anj_740dae6c_8486_40d7_94b0_88bcfde1530d?: { init: () => void; }; }
}

const SCRIPT_SRC = 'https://740dae6c-8486-40d7-94b0-88bcfde1530d.snippet.anjouangaming.org/anj-seal.js';

export default function SealScriptLoader() {
  return (
    <Script
      src={SCRIPT_SRC}
      strategy="lazyOnload"
      onLoad={() => {
        window.anj_740dae6c_8486_40d7_94b0_88bcfde1530d?.init();
      }}
    />
  );
}
